var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{staticClass:"accordion-item--container"},[_c('v-expansion-panel-header',{class:_vm.titleClass},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }